import React, { useEffect, useState } from "react";
import { PageWrapperTwoColumn } from "@cs/components/src/PageWrapper";
import PageTitle from "@cs/components/src/PageTitle";
import PluginInstanceForm from "./PluginInstanceForm";
import PluginInstanceList from "./PluginInstanceList";
import { Route, Routes, useParams } from "react-router-dom";
import AddPluginList from "./AddPluginList";
import LegacyComponentView from "./LegacyComponentView";

export interface Status {
  status: string;
  message?: string;
}

const PluginInstanceEditScreen = () => {
  const { systemDomainId } = useParams();
  const [editedPluginInstances, setEditedPluginInstances] = useState<
    Record<string, PluginInstanceItem>
  >({});
  const [statuses, setStatuses] = useState<Record<string, Status>>({});
  const onChange = (pluginInstance: PluginInstanceItem) => {
    setEditedPluginInstances({
      ...editedPluginInstances,
      [pluginInstance.id]: pluginInstance,
    });
  };

  useEffect(() => {
    setEditedPluginInstances({});
    setStatuses({});
  }, [systemDomainId]);

  return (
    <>
      <PageTitle
        title="Plugins"
        dirty={Object.values(statuses).some(({ status }) => status === "dirty")}
      ></PageTitle>

      <PageWrapperTwoColumn>
        <PluginInstanceList
          editedPluginInstances={editedPluginInstances}
          statuses={statuses}
        />
        <Routes>
          <Route
            path="new"
            element={
              <AddPluginList
                onAdd={(pluginInstance) => {
                  onChange(pluginInstance);
                  setStatuses({
                    ...statuses,
                    [pluginInstance.id]: {
                      status: "dirty",
                    },
                  });
                }}
              />
            }
          />
          <Route path="legacy/:componentId" element={<LegacyComponentView />} />
          <Route
            path=":pluginId"
            element={
              <PluginInstanceForm
                editedPluginInstances={editedPluginInstances}
                onChange={onChange}
                onStatusChange={(id, status, message) => {
                  setStatuses({
                    ...statuses,
                    [id]: {
                      status,
                      message,
                    },
                  });
                }}
                statuses={statuses}
                onRemove={(id) => {
                  const updatedPluginInstances = { ...editedPluginInstances };
                  delete updatedPluginInstances[id];
                  setEditedPluginInstances(updatedPluginInstances);
                  const updatedStatuses = { ...statuses };
                  delete updatedStatuses[id];
                  setStatuses(updatedStatuses);
                }}
              />
            }
          />
        </Routes>
      </PageWrapperTwoColumn>
    </>
  );
};

export default PluginInstanceEditScreen;
